import gql from 'graphql-tag';

const GraphQL = {
  Query: {
    IS_USERNAME_AVAILABLE: gql`
      query IsUsernameAvailable($username: String!) {
        isUsernameAvailable(username: $username)
      }
    `,
    ZONES: gql`
      query Zones($multicode: String!) {
        zones(multicode: $multicode) {
          name
        }
      }
    `,
    LINKED_ACCOUNTS: gql`
      query LinkedAccounts($parentkey: Int!) {
        linkedAccounts(parentkey: $parentkey) {
          parentkey
          userkey
          username
          firstname
          lastname
        }
      }
    `
  },
  Mutation: {
    CREATE_LINKED_ACCOUNT: gql`
      mutation CreateLinkedAccount($input: LinkedAccountRequestInput!) {
        createLinkedAccount(input: $input)
      }
    `,
    UPDATE_LINKED_ACCOUNT: gql`
      mutation UpdateLinkedAccount($input: LinkedAccountUpdateInput!) {
        updateLinkedAccount(input: $input)
      }
    `,
    JOIN_LINKED_ACCOUNTS: gql`
      mutation JoinLinkedAccounts($usernames: [String]!, $multicode: String!) {
        joinLinkedAccounts(usernames: $usernames, multicode: $multicode)
      }
    `,
    REMOVE_LINKED_ACCOUNT: gql`
      mutation RemoveLinkedAccount($userkey: Int!) {
        removeLinkedAccount(userkey: $userkey)
      }
    `
  }
};

export default GraphQL;
